module.exports = __webpack_public_path__ + "img/general-nutrition-icon.3c1ac359.svg";